exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tickets {\n  margin: 120px 0 30px 0;\n}\n.tickets .successImage {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  -webkit-transform: translate3d(-50%, -50%, 0);\n          transform: translate3d(-50%, -50%, 0);\n}\n\n@media (max-width: 768px){\n  .tickets .successImage {\n    width: 100px;\n  }\n}\n\n.tickets_markdown h1, .tickets_markdown h2, .tickets_markdown h3, .tickets_markdown h4, .tickets_markdown h5{\n  text-align: center;\n}\n.tickets_markdown h4{\n  padding: 30px 0 38px;\n  margin: 0 80px;\n}\n", ""]);

// exports
